import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.section`
    color: ${vars.colorPrimary};

    .content-wrapper {
        margin-top: 2em;
        margin-bottom: 6em;
        padding-right: 6em;
        display: flex;
        gap: 3em;
        justify-content: center;

        @media screen and (max-width: ${vars.desktopXS}) {
            padding-right: 0em;
            flex-direction: column;
            align-items: center;
        }
    }
`;
